import React, { useState, useEffect, useMemo } from 'react';
import Img from 'gatsby-image';
import { useIntl } from 'gatsby-plugin-intl';
import { isMobile } from 'react-device-detect';
import Dialog from '@material-ui/core/Dialog';
import ButtonBase from '@material-ui/core/ButtonBase';
import { openWhats } from '../../libs/util/utils';
import ImagemIconeWhats from '../../images/comunicado-final-de-ano-icone-whats.svg';
import ImagemIconeFechar from '../../images/comunicado-final-de-ano-icone-fechar.png';
import './style.scss';

const SESSION_AVISO_FERIAS = 'avisoDeFeriasFechado-2023-2024';

export default ({ data }) => {
  const intl = useIntl();

  const {
    imagemAvisoFeriasFundo, imagemAvisoFeriasFundoMobile,
    imagemAvisoFeriasLogoIdeia, imagemAvisoFeriasEnfeite,
  } = data;

  const imagemFundo = useMemo(() => imagemAvisoFeriasFundo.nodes.find(
    (dataImagem) => dataImagem.name === 'comunicado-final-de-ano-fundo'
  ), [imagemAvisoFeriasFundo]);

  const imagemFundoMobile = useMemo(() => imagemAvisoFeriasFundoMobile.nodes.find(
    (dataImagem) => dataImagem.name === 'comunicado-final-de-ano-fundo-mobile'
  ), [imagemAvisoFeriasFundoMobile]);

  const imagemLogoIdeia = useMemo(() => imagemAvisoFeriasLogoIdeia.nodes.find(
    (dataImagem) => dataImagem.name === 'comunicado-final-de-ano-logo-ideia'
  ), [imagemAvisoFeriasLogoIdeia]);

  const imagemEnfeite = useMemo(() => imagemAvisoFeriasEnfeite.nodes.find(
    (dataImagem) => dataImagem.name === 'comunicado-final-de-ano-enfeite'
  ), [imagemAvisoFeriasEnfeite]);

  const [exibeAviso, setExibeAviso] = useState(false);

  useEffect(() => {
    // se ja fechou o aviso nessa sessão, então n abre novamente
    if (sessionStorage.getItem(SESSION_AVISO_FERIAS)) return;

    setExibeAviso(true);
  }, []);

  const fechaAviso = () => {
    // salva flag na sessão para n abrir novamente na mesma sessão
    sessionStorage.setItem(SESSION_AVISO_FERIAS, '1');

    setExibeAviso(false)
  };

  return (
    <Dialog
      onClose={fechaAviso}
      open={exibeAviso}
      classes={{
        paper: 'paper-aviso-ferias-mobile',
      }}
      aria-labelledby="aviso-de-ferias"
    >
      <div className="btn-fecha-aviso">
        <ButtonBase
          type="button"
          aria-label={intl.formatMessage({ id: 'Fecha aviso' })}
          onClick={fechaAviso}
          focusRipple
        >
          <img src={ImagemIconeFechar} alt="icone fechar" />
        </ButtonBase>
      </div>
      <div className="container-imagem-enfeite">
        <Img
          fixed={imagemEnfeite?.childImageSharp?.fixed}
          alt="imagem-aviso-ferias"
        />
      </div>
      <div className="container-dialog-aviso-ferias">
        <div className="imagem-fundo-desktop">
          <Img
            fixed={imagemFundo?.childImageSharp?.fixed}
            alt="imagem-aviso-ferias"
          />
        </div>
        <div className="imagem-fundo-mobile">
          <Img
            fixed={imagemFundoMobile?.childImageSharp?.fixed}
            alt="imagem-aviso-ferias"
          />
        </div>
        <div className="content-aviso-ferias">
          <Img
            fixed={imagemLogoIdeia?.childImageSharp?.fixed}
            alt="imagem-logo-ideia2001"
          />

          <p className="titulo-aviso-ferias">
            {intl.formatMessage({ id: 'Estaremos de férias no período de 20/12 até 03/01.' })}
          </p>

          <p className="subtitulo-aviso-ferias">
            {intl.formatMessage({ id: 'Atendimentos durante esse período:' })}
          </p>

          <p className="texto-aviso-ferias texto-suporte">
            {intl.formatMessage({ id: 'Suporte: Terça a sexta: 09h às 17h' })}
          </p>

          <div className="container-botao-contato">
            <a href="mailto:suporte@ideia2001.com.br" className="texto-aviso-ferias">
              suporte@ideia2001.com.br
            </a>
          </div>

          <div className="container-botao-contato">
            <a href="tel:551129175277" className="texto-aviso-ferias">
              {intl.formatMessage({ id: 'Fone:' })} 55 11 2917-5277
            </a>
          </div>

          <div className="container-botao-contato">
            <button onClick={() => openWhats('551129175277', isMobile)} className="container-icone-whats">
              <img src={ImagemIconeWhats} alt="icone whats" />

              <p className="texto-aviso-ferias">
                Whatsapp: 55 11 2917-5277
              </p>
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
